'use es6';

import { Map as ImmutableMap } from 'immutable';
import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { LS_SOURCE_OF_CURRENT_DRAG } from 'ContentEditorUI/lib/layoutSection/dom';
import { getDndAreaElementForNode } from 'layout-dnd-utils/dom/dndAreaDomSelectors';
import { getCurrentDragItem } from 'InpageEditorUI/redux/selectors/layoutSectionDndSelectors';
import { getAllLayoutSectionTreesAsMap, getAllGridLayoutTreesAsMap } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { getImmutableOrPlain } from 'ContentEditorUI/utils/dataHelpers';
import { getGridNodeElement } from 'layout-dnd-utils/nodePositions/nodePositionGridLayoutTreeUtils';
const mapStateToProps = state => {
  return {
    currentDragItem: getCurrentDragItem(state),
    allLayoutSectionTreesAsMap: getAllLayoutSectionTreesAsMap(state),
    allGridLayoutTreesAsMap: getAllGridLayoutTreesAsMap(state)
  };
};
class LayoutSectionDragDomManipulationContainer extends Component {
  componentDidUpdate(prevProps) {
    const {
      currentDragItem
    } = this.props;
    if (prevProps.currentDragItem !== currentDragItem) {
      if (this.isValidDragItemFromDocument(prevProps.currentDragItem)) {
        this.removeSourceOfCurrentDragClassname(prevProps.currentDragItem);
      }
      if (this.isValidDragItemFromDocument(currentDragItem)) {
        this.addSourceOfCurrentDragClassname(currentDragItem);
      }
    }
  }
  isValidDragItemFromDocument(dragItem) {
    return dragItem && getImmutableOrPlain(dragItem, 'dragId') && !getImmutableOrPlain(dragItem, 'fromInpageSidebar', false);
  }
  getRowOrColumnElementFromDragItem(dragItem, tree) {
    const node = getImmutableOrPlain(dragItem, 'isRow') ? tree.findRow(getImmutableOrPlain(dragItem, 'dragId')) : tree.findCell(getImmutableOrPlain(dragItem, 'dragId'));
    return getDndAreaElementForNode(node);
  }
  getGridLayoutElementFromDragItem(dragItem, tree) {
    const node = tree.findNode(getImmutableOrPlain(dragItem, 'dragId'));
    return getGridNodeElement(node);
  }
  removeSourceOfCurrentDragClassname(dragItem) {
    const {
      allLayoutSectionTreesAsMap,
      allGridLayoutTreesAsMap
    } = this.props;
    const layoutSectionOriginTree = allLayoutSectionTreesAsMap[getImmutableOrPlain(dragItem, 'originLayoutSectionId')];
    const gridLayoutOriginTree = allGridLayoutTreesAsMap[getImmutableOrPlain(dragItem, 'originLayoutSectionId')];
    if (layoutSectionOriginTree) {
      this.getRowOrColumnElementFromDragItem(dragItem, layoutSectionOriginTree).classList.remove(LS_SOURCE_OF_CURRENT_DRAG);
    } else if (gridLayoutOriginTree) {
      this.getGridLayoutElementFromDragItem(dragItem, gridLayoutOriginTree).classList.remove(LS_SOURCE_OF_CURRENT_DRAG);
    }
  }
  addSourceOfCurrentDragClassname(dragItem) {
    const {
      allLayoutSectionTreesAsMap,
      allGridLayoutTreesAsMap
    } = this.props;
    const layoutSectionOriginTree = allLayoutSectionTreesAsMap[getImmutableOrPlain(dragItem, 'originLayoutSectionId')];
    const gridLayoutOriginTree = allGridLayoutTreesAsMap[getImmutableOrPlain(dragItem, 'originLayoutSectionId')];
    if (layoutSectionOriginTree) {
      this.getRowOrColumnElementFromDragItem(dragItem, layoutSectionOriginTree).classList.add(LS_SOURCE_OF_CURRENT_DRAG);
    } else if (gridLayoutOriginTree) {
      this.getGridLayoutElementFromDragItem(dragItem, gridLayoutOriginTree).classList.add(LS_SOURCE_OF_CURRENT_DRAG);
    }
  }
  render() {
    return null;
  }
}
LayoutSectionDragDomManipulationContainer.propTypes = {
  currentDragItem: PropTypes.oneOfType([PropTypes.instanceOf(ImmutableMap), PropTypes.object]),
  allLayoutSectionTreesAsMap: PropTypes.object.isRequired,
  allGridLayoutTreesAsMap: PropTypes.object.isRequired
};
export default connect(mapStateToProps)(LayoutSectionDragDomManipulationContainer);